import * as React from 'react';
import clsx from 'clsx';

type Props = {
	children: string | JSX.Element | (string | JSX.Element)[];
	color?: string;
	innerHtml?: boolean;
	className?: string;
};

export const Paragraph = ({
	children,
	color = 'text-ep-navy',
	innerHtml = false,
	className,
}: Props) => {
	if (innerHtml) {
		return (
			<p
				className={clsx(
					'font-body text-body leading-snug text-inherit font-light',
					{ 'mb-4': !className?.includes('mb-') },
					color,
					className
				)}
				dangerouslySetInnerHTML={{ __html: children }}
			/>
		);
	}
	return (
		<p
			className={clsx(
				'font-body text-body leading-snug font-light',
				{ 'mb-4': !className?.includes('mb-') },
				color,
				className
			)}
		>
			{children}
		</p>
	);
};
